import {
  React,
  Component,
  PropTypes
} from 'imports/CommonImports';

import {RaisedButton} from 'material-ui';

const styles = {
  button: {
    width: '15em',
  },
  buttonStyle:{
    border: '1px solid #1B2543'
  }
}

class SecondaryButton extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    return(
      <RaisedButton
        disabled={this.props.disabled}
        labelColor='#1B2543'
        backgroundColor='#FFFFFF'
        label={this.props.label}
        onClick={this.props.onClick}
        style={this.props.style || styles.button}
        href={this.props.href}
        buttonStyle={styles.buttonStyle}
        labelPosition={this.props.labelPosition}
        icon={this.props.icon}
        />
    );
  }
}

SecondaryButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string
}

export default SecondaryButton;



// WEBPACK FOOTER //
// ./src/components/design/SecondaryButton.js